<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-text-field
          v-model="title"
          label="Notification Title"
          prepend-inner-icon="mdi-format-title"
          required
          hint="This will also be the subject of the email received by the tenant"
          persistent-hint
          :rules="titleRules"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0" cols="12" sm="12" md="12">
        <v-select
          v-model="type"
          :items="types"
          label="Notification type"
          prepend-inner-icon="mdi-swap-horizontal"
          class="pt-0"
          outlined
          dense
          hide-details
        ></v-select>
      </v-col>
    </v-row>

    <v-divider class="my-4"></v-divider>

    <v-row v-if="type === 'DUE_DATE'">
      <v-col class="py-0" cols="12" sm="12" md="12">
        <v-select
          v-model="selectedCategories"
          :items="paymentCategories"
          label="Select Categories"
          prepend-inner-icon="mdi-tools"
          class="pt-0"
          :rules="categoryRules"
          small-chips
          multiple
          outlined
          dense
        ></v-select>
      </v-col>
    </v-row>

    <p class="body-1">Notification date (relative to date)</p>

    <v-row v-for="(notif, index) in frequency" :key="index">
      <v-col cols="12" sm="3" md="3">
        <v-text-field
          v-model="notif.duration"
          type="number"
          prepend-inner-icon="mdi-calendar"
          hide-details
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3" md="3">
        <v-select
          v-model="notif.unit"
          :items="durationUnits"
          hide-details
          outlined
          dense
        >
        </v-select>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-select
          v-model="notif.beforeOrAfter"
          :items="beforeOrAfterOptions"
          hide-details
          outlined
          dense
        >
          <template v-slot:append-outer>
            <v-icon color="red" @click="removeNotif(index)"
              >mdi-close-circle</v-icon
            >
          </template>
        </v-select>
      </v-col>
    </v-row>
    <v-btn class="mt-2" color="primary" text @click="addNotifs">Add more</v-btn>

    <v-divider class="my-4"></v-divider>

    <p class="caption">Email Message</p>
    <v-row>
      <v-col>
        <jodit-editor
          v-model="emailMessage"
          :buttons="joditButtons"
          :extra-buttons="joditCustomButtons"
        />
      </v-col>
    </v-row>
    <br />
    <p class="caption">SMS Message (up to 140 characters)</p>
    <v-row>
      <v-col>
        <jodit-editor
          v-model="smsMessage"
          :buttons="[]"
          :extra-buttons="joditCustomButtons"
          :config="joditSMSConfig"
        />
      </v-col>
    </v-row>

    <v-divider class="my-4"></v-divider>

    <p class="caption">Other Options</p>

    <v-row>
      <v-col>
        <v-switch
          v-model="attachSOA"
          class="my-0"
          label="Attach SOA"
        ></v-switch>
      </v-col>
      <v-col>
        <v-switch
          v-model="bccPropertyEmail"
          class="my-0"
          label="BCC property email"
        ></v-switch>
      </v-col>
    </v-row>

    <p class="caption">Danger Zone</p>

    <v-row>
      <v-col>
        <v-switch
          v-model="inactive"
          class="my-0"
          label="Deactivated"
          color="red"
          hint="Deactivating a notification prevents any notification from being triggered and sent to the tenant"
          persistent-hint
        ></v-switch>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import 'jodit/build/jodit.min.css'
import { JoditEditor } from 'jodit-vue'

export default {
  components: {
    JoditEditor
  },
  props: ['params'],
  data() {
    return {
      title: '',
      type: 'DUE_DATE',
      paymentCategories: [],
      selectedCategories: [],
      durationUnits: [
        { text: 'Days', value: 'day' },
        { text: 'Weeks', value: 'week' },
        { text: 'Months', value: 'month' },
        { text: 'Years', value: 'year' }
      ],
      frequency: [{ duration: 1, unit: 'day', beforeOrAfter: 1 }],
      titleRules: [(v) => v.length > 0 || 'Title cannot be empty'],
      categoryRules: [(v) => v.length > 0 || 'Please select a category'],
      emailMessage: '',
      smsMessage: '',
      joditButtons: [
        'bold',
        'underline',
        'italic',
        '|',
        'left',
        'center',
        'right',
        'justify',
        '|',
        'font',
        'fontsize'
      ],
      joditCustomButtons: [
        {
          name: 'Tenant name',
          exec: (editor) => {
            editor.selection.insertHTML(`{{TENANT}}`)
          }
        },
        {
          name: 'Pending balance',
          exec: (editor) => {
            editor.selection.insertHTML(`{{PENDING_BALANCE}}`)
          }
        },
        {
          name: 'Due date',
          exec: (editor) => {
            editor.selection.insertHTML(`{{DUE_DATE}}`)
          }
        },
        {
          name: 'Days Overdue',
          exec: (editor) => {
            editor.selection.insertHTML(`{{DAYS_OVERDUE}}`)
          }
        },
        {
          name: 'Period',
          exec: (editor) => {
            editor.selection.insertHTML(`{{PERIOD}}`)
          }
        },
        {
          name: 'Amount',
          exec: (editor) => {
            editor.selection.insertHTML(`{{AMOUNT}}`)
          }
        }
      ],
      joditSMSConfig: {
        limitChars: 140
      },
      attachSOA: false,
      bccPropertyEmail: false,
      inactive: false
    }
  },
  computed: {
    property() {
      return this.$store.getters['properties/getProperty']
    },
    types() {
      return [
        {
          text: 'Payment due date',
          value: 'DUE_DATE'
        },
        {
          text: 'Move in date',
          value: 'MOVE_IN_DATE'
        },
        {
          text: 'Move out date',
          value: 'MOVE_OUT_DATE'
        }
      ]
    },
    beforeOrAfterOptions() {
      return [
        { text: `After ${this.beforeOrAfterTypeMapper()}`, value: 1 },
        { text: `Before ${this.beforeOrAfterTypeMapper()}`, value: -1 }
      ]
    }
  },
  mounted() {
    if (this.params) {
      this.title = this.params.title
      this.selectedCategories = this.params.categories
      this.emailMessage = this.params.emailMessage
      this.smsMessage = this.params.smsMessage
      this.attachSOA = this.params.attachSOA
      this.bccPropertyEmail = this.params.bccPropertyEmail
      this.inactive = this.params.inactive
      this.frequency = this.deconstructFrequencyData(this.params.frequency)
    }
    this.paymentCategories =
      this.property.payment_categories_details[0].categories
  },
  methods: {
    addNotifs() {
      this.frequency.push({ duration: 1, unit: 'day', beforeOrAfter: 1 })
    },
    removeNotif(index) {
      this.frequency.splice(index, 1)
    },
    deconstructFrequencyData(frequencies) {
      if (frequencies) {
        return frequencies.map((frequency) => ({
          ...frequency,
          beforeOrAfter: frequency.duration > 0 ? 1 : -1,
          duration: Math.abs(frequency.duration)
        }))
      }
    },
    constructFrequencyData(frequencies) {
      if (frequencies) {
        return frequencies.map((frequency) => ({
          ...frequency,
          duration: frequency.duration * frequency.beforeOrAfter
        }))
      }
    },
    emitData() {
      this.$emit('updateData', {
        title: this.title,
        categories: this.selectedCategories,
        type: this.type,
        emailMessage: this.emailMessage,
        smsMessage: this.smsMessage,
        attachSOA: this.attachSOA,
        bccPropertyEmail: this.bccPropertyEmail,
        inactive: this.inactive,
        frequency: this.constructFrequencyData(this.frequency)
      })
    },
    beforeOrAfterTypeMapper() {
      switch (this.type) {
        case 'DUE_DATE':
          return 'due date'
        case 'MOVE_IN_DATE':
          return 'move in date'
        case 'MOVE_OUT_DATE':
          return 'move out date'
        default:
          return 'date'
      }
    }
  }
}
</script>

<style>
p {
  margin-bottom: 0 !important;
}
</style>
